// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "a4634e51" + "-" + "7e1cb3ce4c87a3f1" + ".js";
};